export default __webpack_public_path__ + "static/media/poorvika-sm-logo.7be00755.png";